import { Button } from "@mui/material";
import Cookies from "js-cookie";
import { MenuItem } from "primereact/menuitem";
import { SplitButton } from "primereact/splitbutton";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import useResize from "src/hooks/useResize";
import { setLanguage } from "src/redux/slices/lookupSlice";
import { LANGuAGE_COOKIE } from "src/resources/constant";
import { Languages } from "src/resources/enum";
import { replaceDefaultArrow } from "src/utils/helpers";

const languages = [
  { code: Languages.English, lang: "English" },
  { code: Languages.Arabic, lang: "العربية" },
];

const LanguageSelector = ({ handleClick }: { handleClick?: () => void }) => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation(["common", "user"]);
  useEffect(() => {
    const selectedLang = Cookies.get(LANGuAGE_COOKIE) || Languages.English;
    i18n.changeLanguage(selectedLang);
    const updateBodyClass = (lang: string) => {
      document.body.classList.remove("lang-en", "lang-ar");
      const langClass = lang === "ar" ? "lang-ar" : "lang-en";
      dispatch(setLanguage(lang));
      Cookies.set(LANGuAGE_COOKIE, lang);
      console.log(langClass);
      document.body.classList.add(langClass);
      document.body.dir = i18n.dir();
    };
    updateBodyClass(selectedLang);

    i18n.on("languageChanged", updateBodyClass);

    return () => {
      i18n.off("languageChanged", updateBodyClass);
    };
  }, [i18n, i18n.language]);

  const changeLanguage = (lng: string | undefined) => {
    i18n.changeLanguage(lng);
    if (handleClick) {
      handleClick();
    }
  };
  const items: MenuItem[] = [
    {
      template: (
        <Button onClick={() => changeLanguage(Languages.English)}>
          English
        </Button>
      ),
    },
    {
      template: (
        <Button onClick={() => changeLanguage(Languages.Arabic)}>
          العربية
        </Button>
      ),
    },
  ];
  const languageRef = useRef(null);
  const { isMobile } = useResize();

  useEffect(() => {
    const menuButtons = document.querySelectorAll(".language-menu-btn");
    const languageTemplate = document.querySelector(
      ".language-header-template-container"
    );

    if (languageTemplate) {
      languageTemplate.remove();
    }
    if (menuButtons) {
      const portalElement = document.createElement("div");
      portalElement.className = "language-header-template-container";
      const spanElement = document.createElement("span");
      const languageName = languages.find(
        (lang) => lang.code === i18n.language
      )?.lang;
      spanElement.textContent = `${languageName}`;
      portalElement.appendChild(spanElement);
      replaceDefaultArrow(portalElement);

      const viewButton = isMobile ? menuButtons[1] : menuButtons[0];

      viewButton?.prepend(portalElement);
    }
  }, [languageRef?.current, i18n?.language]);
  return (
    <SplitButton
      ref={languageRef}
      model={items}
      menuButtonClassName="language-menu-btn fit-content"
      menuClassName="dropdown-menu-items language-dropdown-menu"
      icon={"pi pi-plus"}
    />
  );
};

export default LanguageSelector;
